// extracted by mini-css-extract-plugin
export default {"label":"EditDuoxuan_label__HjORX","InputOption":"EditDuoxuan_InputOption__WAi5c","OptionCheckbox":"EditDuoxuan_OptionCheckbox__wvQsY"};